import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { iconColors, iconSizes } from '@app/shared/constants';

@Component({
  selector: 'input-error',
  templateUrl: 'input-error.component.html',
  styleUrls: ['input-error.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InputErrorComponent {
  @Input() public isBlue = false;
  @Input() public announceError = 0;

  public iconColors = iconColors;
  public iconSizes = iconSizes;
}
